import { Router, NavigationEnd } from "@angular/router";
import { Injectable } from "@angular/core";
import { IAppcuesOnboardingService } from "../interfaces/service";
import { AppcuesOnboardingRouteObserver } from "./route-observer.service";
import { IOnboardingUserData } from "../interfaces/models";
export const AppcuesSDK = window["Appcues"] || {};

@Injectable()
export class AppcuesOnboardingService implements IAppcuesOnboardingService {
    public userRegistered: IOnboardingUserData;

    constructor(protected routeObserver: AppcuesOnboardingRouteObserver) {}

    public sendDataToAppcues(user: IOnboardingUserData) {
        const isInMobileApp = window["isToroMobile"] ? true : false;

        Object.keys(user).forEach((item) => {
            if (user[item] === undefined) {
                delete user[item] === undefined;
                return user[item];
            }
        });

        if (!isInMobileApp) {
            AppcuesSDK.identify(user.id, user);
        }
    }

    public saveUserDataInAppCues(user: IOnboardingUserData) {
        if (user.id) {
            const isTheFirstTimeWhichThisUserWasRegitered =
                this.userRegistered == null ||
                this.userRegistered.id !== user.id;

            this.sendDataToAppcues(user);

            if (isTheFirstTimeWhichThisUserWasRegitered) {
                this.routeObserver.listen();
                this.userRegistered = user;
            }
        }
    }

    public listenEventAndTriggerATask(namOfEvent: string, callBackAction = {}) {
        if (AppcuesSDK.on) {
            AppcuesSDK.on(namOfEvent, callBackAction);
        }
    }

    public saveUserAccountStatus(userData: {
        id: number;
        accountStatus: string;
    }) {
        try {
            if (!userData.id) {
                throw "User need an ID for realize this operation";
            }
            this.sendDataToAppcues(userData);
        } catch (error) {
            throw error;
        }
    }
}
